export default __webpack_public_path__ + "static/media/logo-full.abbda5ac.png";